module.exports = __webpack_public_path__ + "img/Kiribati.b9e4e4a5.svg";